// extracted by mini-css-extract-plugin
export default {"container":"BaseTab_container__yS0G+","bordered":"BaseTab_bordered__9d9Tb"};